import { useCallback } from 'react';
import toast from 'react-hot-toast';

import { useLazyGetContactResumeQuery } from '../services/contactsV2';

export function useSecurePdfOpener() {
  const [getContactResume, { isLoading: isLoadingResume }] = useLazyGetContactResumeQuery();

  const openSecurePdf = useCallback(
    (contactId) => {
      getContactResume({ id: contactId })
        .unwrap()
        .then((response) => {
          window.open(response.resumeUrl, '_blank');
        })
        .catch(() => {
          toast('Error opening PDF.', { icon: 'error', id: 'pdf-open-error' });
        });
    },
    [getContactResume],
  );

  return { openSecurePdf, isLoading: isLoadingResume };
}
